import Vue from 'vue';

Vue.directive('sticky-component', function(el, binding) {
  window.onscroll = () => {
    const sticky = el.offsetTop;
    if (window.pageYOffset > sticky) {
      el.classList.add(binding.value || 'sticky');
    } else {
      el.classList.remove(binding.value || 'sticky');
    }
  };
});
